import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  notifications: [],
  hasUnread: false,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotifications: (state, action) => {
      state.notifications = action.payload;
      state.hasUnread = action.payload.some(n => !n.read);
    },
    markAllAsRead: (state) => {
      state.notifications = state.notifications.map(n => ({ ...n, read: true }));
      state.hasUnread = false;
    },
    setHasUnread: (state, action) => {
      state.hasUnread = action.payload;
    },
  },
});

export const { setNotifications, markAllAsRead, setHasUnread } = notificationSlice.actions;
export default notificationSlice.reducer;
